export class PaginatedSearchRequestDto {
  pageNumber: number | null = 1;
  pageSize: number | null = 10;
  searchTerm: string | null = '';

  constructor(init?: Partial<PaginatedSearchRequestDto>) {
    if (init) Object.assign(this, init);
  }

  toQueryString(): string {
    const params = new URLSearchParams();
    Object.entries(this).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value.toString());
      }
    });
    return params.toString();
  }
}